<template>
    <div class="dropzone">
        <!-- Component to upload file -->
        <dropzone-file-uploader
            v-show="!uploadedFile"
            :name="name"
            :accept="accept"
            :multiple="multiple"
            @change="onChange"
        ></dropzone-file-uploader>

        <!-- Show already uploaded file -->
        <dropzone-uploaded-file
            :uploaded-file="uploadedFile"
            @remove="onRemove"
        >
        </dropzone-uploaded-file>

        <!-- Validation error message -->
        <span class="invalid-feedback" v-if="error">
            <strong>{{error}}</strong>
        </span>
    </div>
</template>

<script>
export default {
    data() {
        return {
            files: [],
            inputElement: null,
            highlightElement: null,
            isHighlighted: false
        };
    },

    props: {
        name: String,
        error: String,
        uploadedFile: String,
        accept: {
            type: String,
            default: '.jpg,.jpeg,.png,.gif,.doc,.docx,.xls,.xlsx,.csv,.pdf,.css'
        },
        multiple: Boolean
    },

    computed: {
        id() {
            return this.name + '-id';
        }
    },

    methods: {
        handleFileUpload() {
            const files = this.inputElement.files;

            this.files.push(...files);
            this.$emit('change', this.files);
        },

        resetFileUpload() {
            this.inputElement.value = '';
            this.files = [];
            this.$emit('change', []);
        },

        addDragAndDropLogic() {
            this.inputElement.addEventListener(
                'dragenter',
                () => (this.isHighlighted = true),
                false
            );
            this.inputElement.addEventListener(
                'dragleave',
                () => (this.isHighlighted = false),
                false
            );
            this.inputElement.addEventListener(
                'drop',
                () => (this.isHighlighted = false),
                false
            );
        },

        onRemove() {
            this.$emit('remove');
        },

        onChange(files) {
            this.$emit('change', files);
        }
    },

    mounted() {
        this.inputElement = document.getElementById(this.id);
        this.highlightElement = this.$el.getElementsByClassName(
            'dropzone__highlight-overlay'
        )[0];

        this.addDragAndDropLogic();
    }
};
</script>
